module.exports = __webpack_public_path__ + "assets/img/67@3x.0d3c6533.png";